import React from 'react'
import Navbar from '../components/Navbar'

const Upload = () => {
  return (
    <>
    <Navbar/>
    <div>Upload</div>
</>
  )
}

export default Upload